import React from 'react';
import { useSettingsSideBarAOMMenu } from './hooks/use-settings-menu-aom.hook';
import { SideMenuList } from './components/side-menu-list';

export const AomSideMenuList: React.FC = () => {
    const sideBarMenuAom = useSettingsSideBarAOMMenu();

    return <SideMenuList items={sideBarMenuAom}></SideMenuList>;
};
